import React from 'react';
// Icons
import { IoIosCloseCircleOutline } from 'react-icons/io';

function ContactFormItem({ form, handleDelete }) {
  return (
    <article
      className="grid gap-y-3 sm:grid-cols-[minmax(0,1fr)_auto] bg-colour2 text-colour1 border-2 border-colour6 border-solid px-3 sm:px-4 py-3 sm:py-4 rounded-sm shadow-sm"
      aria-label={`Contact form submission from ${form.firstName} ${form.lastName}`}
    >
      {/* Content Section */}
      <section
        aria-labelledby={`contact-heading-${form.id}`}
        className="grid gap-y-1.5"
      >
        <h2 id={`contact-heading-${form.id}`} className="sr-only">
          Contact Form Submission Details
        </h2>

        <p className="text-sm leading-relaxed">
          <span className="font-semibold uppercase text-xs tracking-wide text-colour7">
            Name
          </span>
          <br />
          {form.firstName} {form.lastName}
        </p>

        <p className="text-sm leading-relaxed">
          <span className="font-semibold uppercase text-xs tracking-wide text-colour7">
            Email
          </span>
          <br />
          <a
            href={`mailto:${form.email}`}
            className="underline underline-offset-2 hover:no-underline break-all"
          >
            {form.email}
          </a>
        </p>

        <p className="text-sm leading-relaxed">
          <span className="font-semibold uppercase text-xs tracking-wide text-colour7">
            Phone Number
          </span>
          <br />
          {form.phoneNumber ? (
            <a
              href={`tel:${form.phoneNumber}`}
              className="underline underline-offset-2 hover:no-underline"
            >
              {form.phoneNumber}
            </a>
          ) : (
            '—'
          )}
        </p>

        <p className="text-sm leading-relaxed">
          <span className="font-semibold uppercase text-xs tracking-wide text-colour7">
            Location
          </span>
          <br />
          {form.location || '—'}
        </p>

        <p className="text-sm leading-relaxed">
          <span className="font-semibold uppercase text-xs tracking-wide text-colour7">
            Message
          </span>
          <br />
          {form.message}
        </p>

        <p className="text-xs text-colour7 mt-1.5">
          <span className="font-semibold uppercase tracking-wide">
            Submitted
          </span>{' '}
          {new Date(form.createdAt).toLocaleString()}
        </p>
      </section>

      {/* Delete Button */}
      <section className="grid items-start justify-end">
        <button
          onClick={() => handleDelete(form.id)}
          className="p-1 rounded-full text-red-500 hover:text-red-700 focus:outline-none focus:ring-2 focus:ring-red-500/60 focus:ring-offset-2 focus:ring-offset-colour2 transition-colors duration-150"
          title={`Delete submission from ${form.firstName} ${form.lastName}`}
          aria-label={`Delete contact form from ${form.firstName} ${form.lastName}`}
        >
          <IoIosCloseCircleOutline className="w-8 h-8" />
        </button>
      </section>
    </article>
  );
}

export default ContactFormItem;
